import { useEffect, useState } from 'react';

import { fetchAggResponse } from '../../../../../common/fetch/fetch-agg-response';
import { logger } from '../../../../../common/utils/logger';
import {
	POPULAR_SEARCH_QUERY_OPERATION_NAME,
	PopularSearchQuery,
} from './PopularSearchQuery.graphql';

type PopularSearchQueryVariables = {
	cloudId: string;
	searchQuery: string;
};

type PopularSearchQueryData = {
	knowledgeDiscovery?: {
		popularSearchQuery: {
			isPopular: boolean;
		};
	};
};

const fetchIsSearchQueryPopular = async (
	variables: PopularSearchQueryVariables,
): Promise<boolean | undefined> => {
	return fetchAggResponse<PopularSearchQueryVariables, PopularSearchQueryData>({
		graphQuery: PopularSearchQuery,
		variables,
		operationName: POPULAR_SEARCH_QUERY_OPERATION_NAME,
	}).then((response) => response.data?.knowledgeDiscovery?.popularSearchQuery.isPopular);
};

type PopularSearchQueryParams = {
	cloudId: string;
	searchQuery: string;
	isEnabled: boolean;
};

export const useIsSearchQueryPopular: ({
	cloudId,
	searchQuery,
	isEnabled,
}: PopularSearchQueryParams) => {
	isPopular: boolean;
	loading: boolean;
	error: boolean;
} = ({ cloudId, searchQuery, isEnabled }: PopularSearchQueryParams) => {
	const [isPopular, setIsPopular] = useState<boolean>(false);
	const [loading, setIsLoading] = useState(true);
	const [error, setError] = useState(false);

	useEffect(() => {
		const fetchIsPopular = async () => {
			try {
				setIsLoading(true);

				const isPopular = await fetchIsSearchQueryPopular({
					cloudId,
					searchQuery,
				});

				setIsPopular(isPopular ?? false);
			} catch (err) {
				logger.error({
					feature: 'bookmarks',
					element: 'container',
					operation: 'fetch',
					category: 'network',
					error: err,
					functionName: 'fetchIsSearchQueryPopular',
				});
				setError(true);
			} finally {
				setIsLoading(false);
			}
		};

		if (!!searchQuery && cloudId && isEnabled) {
			fetchIsPopular();
		}
	}, [cloudId, searchQuery, isEnabled]);

	return {
		isPopular,
		loading,
		error,
	};
};
